import { ReactElement } from 'react';

import AccessFeatureAlert from '../Alert';
import AccessFeatureHidden from '../Hidden';

import { AccessFeatureGateProps } from './types';

const AccessFeatureGate = ({
  validFeature,
  availableToDate,
  validDemo,
  type,
  hideAlert = false,
  alertProps,
  children,
}: AccessFeatureGateProps): ReactElement => (
  <>
    {!hideAlert && (
      <AccessFeatureAlert
        validFeature={validFeature}
        availableToDate={availableToDate}
        {...alertProps}
      />
    )}

    <AccessFeatureHidden
      validFeature={validFeature}
      availableToDate={availableToDate}
      type={type}
      validDemo={validDemo}
    >
      {children}
    </AccessFeatureHidden>
  </>
);

export default AccessFeatureGate;
